module.exports = __webpack_public_path__ + "img/vladmir.a0e12978.png";